import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=f524e0c0&scoped=true&"
import script from "./ScrollToTop.vue?vue&type=script&lang=ts&"
export * from "./ScrollToTop.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&id=f524e0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f524e0c0",
  null
  
)

export default component.exports